export default __webpack_public_path__ + "static/media/room.4746778d.png";